import { Trans, useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@sib/auth';
import { LoginPageLayout } from '@sib/ui';
import {
  PRIVACY_POLICY_URL,
  TERMS_OF_USE_URL,
} from '@spendbrain/config/constants';
import { paths } from '@spendbrain/config/paths';
import { useLogin } from '../hooks/use-login';

export const Login = () => {
  const { t } = useTranslation();

  const { mutate: login, isPending } = useLogin();

  const { isAuthenticated } = useAuthStore();

  if (isAuthenticated) return <Navigate to={paths.dashboard} />;

  return (
    <LoginPageLayout
      title={t('loginPage.title')}
      description={t('loginPage.description')}
      isLoading={isPending}
      login={login}
      backgroundImageSrc="login-page.png"
      buttonBaseText={t('loginPage.buttonBaseText')}
      buttonLoadingText={t('loginPage.buttonLoadingText')}
      infoMessage={t('loginPage.infoMessage')}
      termsInfo={
        <Trans
          i18nKey={'loginPage.termsOfUseHint'}
          t={t}
          components={{
            termsLink: (
              <a
                href={TERMS_OF_USE_URL}
                target="_blank"
                className="leading-3 text-inherit underline"
              />
            ),
            privacyLink: (
              <a
                href={PRIVACY_POLICY_URL}
                target="_blank"
                className="leading-3 text-inherit underline"
              />
            ),
          }}
        />
      }
    />
  );
};
